module.exports = __webpack_public_path__ + "static/media/fr.4e3ec048.svg";